export default __webpack_public_path__ + "static/media/video.08d59caf.svg";